module.exports = __webpack_public_path__ + "assets/materialdesignicons-webfont.woff2?32562ea54b66a048a7d093eb6f595faa";